import React from 'react';
import { Link } from 'react-router-dom';
import { useData } from '../../context/DataContext';
import '../../styles/components/Hero.css';

const Hero = () => {
  const { data, getUIText } = useData();
  const homeUI = getUIText('home');
  const images = data?.images || {};

  return (
    <section className="hero">
      <div className="hero-background">
        <img
          src={images?.backgrounds?.hero}
          alt={`${data?.name} - Hero`}
          className="hero-image"
        />
        <div className="hero-overlay"></div>
      </div>

      <div className="hero-content">
        <h1 className="hero-title">{data?.name}</h1>
        <p className="hero-subtitle">{data?.tagline}</p>
        <p className="hero-description">{data?.description}</p>

        <div className="hero-buttons">
          {homeUI?.heroButtons?.map((button, index) => (
            <Link
              key={index}
              to={button.link}
              className={`hero-btn ${button.type === 'primary' ? 'btn-primary' : 'btn-secondary'}`}
            >
              {button.text}
            </Link>
          ))}
        </div>
      </div>

      {/* Decorative mandala corners */}
      <div className="hero-decor hero-decor-left"></div>
      <div className="hero-decor hero-decor-right"></div>
    </section>
  );
};

export default Hero;
